export default {
    label:{
        textAlign: 'left',
        fontFamily: 'AvenirNext',
        fontSize: '10px',
        fontWeight: 500,
        color: '#96979a',
        marginBottom: '5px',
        textTransform: 'uppercase'
    },
    Panel: {
        backgroundColor: '#f3f3f3',
        padding: '15px 15px 0 15px',
    },
    LogoRow: {
        margin: '10px 10px 10px ',
        alignItems: 'center'
    },
    LogoCol: {
        padding: '0 10px',
        margin: '0 15px',
        maxWidth: 39,
    },
    logo: {

        maxWidth: 39,
        maxHeight: 39,
        marginRight: 4,
        objectFit: 'cover',
        textAlign: 'center',
        borderRadius: '50%',
    },
    Row: {
    },
    Col: {
        padding: '0 10px',
        margin: '10px 15px'
    },
    checkboxRow: {
        margin: '10px 15px'
    },
}
